package com.findyourbuddies.website.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.fontFamily
import org.jetbrains.compose.web.css.fontStyle
import org.jetbrains.compose.web.css.fontWeight

val WaxeTextStyle = CssStyle {
    base {
        Modifier.styleModifier {
            fontFamily("'Waxe', 'Arial Black', 'Helvetica Neue', sans-serif")
            fontWeight("normal")
            fontStyle("normal")
        }
    }
}

val ComfortaaTextStyle = CssStyle {
    base {
        Modifier.styleModifier {
            fontFamily("'Comfortaa', 'Arial', 'Helvetica Neue', sans-serif")
            fontWeight("normal")
            fontStyle("normal")
        }
    }
}
